﻿const camelcaseKeys = require('camelcase-keys-deep');

export default class ApiClient {
    constructor(options) {
        if (typeof options !== 'undefined') {
            this.baseUrl = options.baseUrl || '';
        }

        return {
            get: this.get,
            put: this.put,
            post: this.post,
            del: this.del
        };
    }

    // public

    get = (endpoint) => {
        return this.makeRequest('GET', endpoint);
    }

    put = (endpoint, data) => {
        return this.makeRequest('PUT', endpoint, data);
    }

    post = (endpoint, data) => {
        return this.makeRequest('POST', endpoint, data);
    }

    del = (endpoint, data) => {
        return this.makeRequest('DELETE', endpoint, data);
    }

    // private

    makeRequest(verb, endpoint, data) {
        // remove undefined props
        if(this.isVerbWithPayload(verb)) {
            Object.keys(data).forEach((key) => (typeof data[key] === 'undefined') && delete data[key]);
        }

        if(window._bazDebug) {
            console.log(`[DEBUG] Making ${verb} request to ${endpoint}`);
            if(this.isVerbWithPayload(verb)) {
                console.warn('[DEBUG] Payload: ');
                console.dir(data);
            }
        }

        return new Promise((resolve, reject) => {
            const settings = {
                method: verb,
                mode: 'cors',
                cache: 'no-cache', //'default',
                headers: new Headers({
                    'Content-Type': 'text/plain'
                }), 
                credentials: 'same-origin', // attach cookies for local domain
                body: this.isVerbWithPayload(verb) ? JSON.stringify(data) : undefined
            };

            fetch(new Request(this.baseUrl + endpoint, settings))
                .then((response) => {
                    if (!response.ok) {
                        reject(response.statusText);
                    }

                    return response.json();
                }).then((data) => {
                    data = camelcaseKeys(data, {deep: true}); 

                    if (data.errorMessage != null) {
                        let error = data.errorMessage;
                        
                        if (data.validationErrors) {
                            error += `: ${data.validationErrors.map(e => e.errorMessage.toLowerCase()).join(', ')}`;
                        }

                        reject(error);
                    }

                    if(window._bazDebug)  {
                        console.warn('[DEBUG] Response data: ');
                        console.dir(data);
                    }

                    resolve(data.result);
                })
                .catch(e => reject(e));

        }); 
    }

    isVerbWithPayload(verb) {
        return verb === 'POST' ||  verb === 'PUT';
    }
}